import React, { useEffect } from 'react';
import TaskIcon from '../../images/Icon20_Task.svg';
import Button from '../Toolbar/Button';
import { connect } from 'react-redux';
import {
  setCursorTooltip,
  updateTool,
} from '../../../../redux/actions/fabric_overlay';
import { __, setTableParams } from '../../../../core/utils';
import { getStatusColor } from './taskStatusColors';
import TaskCursorIcon from '../../images/Icon20_Task.png';

const Task = ({
  fabric_overlay: { viewer, fabricOverlay },
  isActive,
  plan,
  table,
  user_id,
}) => {
  useEffect(() => {
    if (!isActive || !fabricOverlay) return;

    const canvas = fabricOverlay.fabricCanvas();

    //canvas.defaultCursor = 'crosshair';
    canvas.defaultCursor = `url(${TaskCursorIcon}) 10 22, auto`;
    //canvas.hoverCursor = 'crosshair';

    setCursorTooltip(__('canvas.tooltip.task'));

    canvas.getObjects().forEach((obj) => {
      obj.selectable = false;
      obj.evented = false;
    });

    function onMouseDown(options) {
      if (options.target || !isActive) return;

      const rawPointer = canvas.getPointer(options.e);

      const x = rawPointer.x;
      const y = rawPointer.y;

      viewer.setMouseNavEnabled(true);

      if (x < 0 || x > plan.width || y < 0 || y > plan.height) {
        return;
      }

      setTableParams('all_tasks', {
        x,
        y,
        attach_task_wizard: true,
        stage_id: plan.stage_id,
      });
    }

    const onPointerDown = (e) => {
      viewer.setMouseNavEnabled(false);
    };

    canvas.upperCanvasEl.addEventListener('pointerdown', onPointerDown);

    canvas.on('mouse:down', onMouseDown);

    return () => {
      canvas.off('mouse:down', onMouseDown);
      canvas.upperCanvasEl.removeEventListener('pointerdown', onPointerDown);
    };
  }, [fabricOverlay, isActive]);

  const createTask = (x, y, taskId, uid, color) => {
    const canvas = fabricOverlay.fabricCanvas();

    const obj = new fabric.Path(
      'M8.67,8.53a28.89,28.89,0,0,0-.41,40.85l.41.41L28.87,69.7a1,1,0,0,0,1.4,0l20.2-19.91a28.9,28.9,0,0,0,.39-40.87l-.39-.39A29.88,29.88,0,0,0,8.67,8.53Z'
    );

    obj.setCoords();

    let lockmov = true;

    if (uid == user_id) lockmov = false;

    obj.set({
      left: x,
      top: y,
      objectType: 'task',
      originalLeft: x,
      originalTop: y,
      taskID: taskId,
      userID: uid,
      //moving: false,
      lockScalingX: true,
      lockScalingY: true,
      // lockMovementX: lockmov,
      // lockMovementY: lockmov,
      hasControls: false,
      hasBorders: false,
      fill: color,
      stroke: color,
    });

    canvas.add(obj);

    //canvas.renderAll();

    viewer.setMouseNavEnabled(true);
  };

  useEffect(() => {
    if (table.task_id) {
      const color = getStatusColor(table.status);

      createTask(table.x, table.y, table.task_id, user_id, color);

      setTableParams('working_set_plans', {
        task_id: undefined,
        x: undefined,
        y: undefined,
      });
    }
  }, [table.task_id]);

  const toggleTool = () => {
    updateTool({ tool: 'task' });
  };

  return (
    <Button
      id='task'
      label={__('canvas.toolbar.task')}
      icon={TaskIcon}
      active={isActive}
      onClick={toggleTool}
      extraClass={['roundedUp', 'withSpacer']}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    fabric_overlay: state.fabric_overlay,
    table: state.table['working_set_plans'],
    user_id: state.auth.id,
  };
};

export default connect(mapStateToProps, null)(Task);
